import SignupForm from "./signup-form";
import { image } from "../../../components/assets/assets";

const signupStyles = `
  /* ============================================================
     SIGNUP PAGE — Premium design matching login page exactly
     ============================================================ */

  .signup-page-wrapper {
    display: flex !important;
    height: 100vh !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
    -webkit-font-smoothing: antialiased;
  }

  /* ============================================================
     LEFT PANEL — Matching login page exactly
     ============================================================ */
  .signup-left-panel {
    width: 45% !important;
    min-width: 45% !important;
    max-width: 45% !important;
    height: 100vh !important;
    background: linear-gradient(135deg, #1e1b4b 0%, #312e81 25%, #3730a3 50%, #4c1d95 75%, #1e1b4b 100%) !important;
    background-size: 300% 300% !important;
    animation: spGradient 12s ease infinite !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
    overflow: hidden !important;
    padding: 40px !important;
    box-sizing: border-box !important;
  }

  @keyframes spGradient {
    0%, 100% { background-position: 0% 50%; }
    25% { background-position: 100% 50%; }
    50% { background-position: 100% 0%; }
    75% { background-position: 0% 100%; }
  }

  /* Aurora ribbon */
  .sp-aurora {
    position: absolute; inset: 0; z-index: 1; opacity: 0.18; overflow: hidden; pointer-events: none;
  }
  .sp-aurora::before {
    content: ''; position: absolute; top: -50%; left: -50%; width: 200%; height: 200%;
    background: conic-gradient(from 0deg at 50% 50%, transparent 0deg, rgba(99,102,241,0.4) 60deg, transparent 120deg, rgba(139,92,246,0.35) 180deg, transparent 240deg, rgba(67,56,202,0.3) 300deg, transparent 360deg);
    animation: spAuroraRot 20s linear infinite; filter: blur(40px);
  }
  .sp-aurora::after {
    content: ''; position: absolute; top: -30%; left: -30%; width: 160%; height: 160%;
    background: conic-gradient(from 180deg at 50% 50%, transparent 0deg, rgba(196,181,253,0.3) 90deg, transparent 180deg, rgba(165,180,252,0.25) 270deg, transparent 360deg);
    animation: spAuroraRot 28s linear infinite reverse; filter: blur(50px);
  }
  @keyframes spAuroraRot { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

  /* Floating orbs */
  .sp-orb {
    position: absolute; border-radius: 50%; pointer-events: none; z-index: 1;
  }
  .sp-orb-1 {
    width: 320px; height: 320px; top: -80px; right: -60px;
    background: radial-gradient(circle, rgba(139,92,246,0.22) 0%, transparent 70%);
    animation: spOrbFloat 14s ease-in-out infinite;
  }
  .sp-orb-2 {
    width: 250px; height: 250px; bottom: 5%; left: -50px;
    background: radial-gradient(circle, rgba(99,102,241,0.20) 0%, transparent 70%);
    animation: spOrbFloat 16s ease-in-out infinite reverse; animation-delay: -4s;
  }
  .sp-orb-3 {
    width: 180px; height: 180px; top: 35%; right: 10%;
    background: radial-gradient(circle, rgba(167,139,250,0.18) 0%, transparent 70%);
    animation: spOrbFloat 12s ease-in-out infinite; animation-delay: -7s;
  }
  @keyframes spOrbFloat {
    0%, 100% { transform: translate(0,0) scale(1); opacity: 0.4; }
    50% { transform: translate(15px,-25px) scale(1.1); opacity: 0.75; }
  }

  /* Grid lines */
  .sp-grid {
    position: absolute; inset: -50px; z-index: 1; opacity: 0.04; pointer-events: none;
    background-image: linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 20%, transparent 70%);
    -webkit-mask-image: radial-gradient(ellipse 70% 70% at 50% 50%, black 20%, transparent 70%);
    animation: spGridDrift 30s linear infinite;
  }
  @keyframes spGridDrift { 0% { transform: translate(0,0); } 50% { transform: translate(12px,12px); } 100% { transform: translate(0,0); } }

  /* Noise texture */
  .sp-noise {
    position: absolute; inset: 0; z-index: 2; opacity: 0.03; pointer-events: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
    background-size: 128px 128px;
  }

  /* Floating particles */
  .sp-particle {
    position: absolute; border-radius: 50%; z-index: 3; pointer-events: none; opacity: 0;
  }
  .sp-particle.sp-drift { animation: spDriftUp 16s linear infinite; }
  .sp-particle.sp-twinkle { animation: spTwinkle 3s ease-in-out infinite; }

  .sp-particle:nth-child(1) { width:4px;height:4px;background:rgba(255,255,255,0.3);top:90%;left:12%;animation-duration:16s;animation-delay:0s; }
  .sp-particle:nth-child(2) { width:3px;height:3px;background:rgba(196,181,253,0.5);top:85%;left:40%;animation-duration:14s;animation-delay:-2s; }
  .sp-particle:nth-child(3) { width:5px;height:5px;background:rgba(165,180,252,0.3);top:80%;left:65%;animation-duration:18s;animation-delay:-5s; }
  .sp-particle:nth-child(4) { width:3px;height:3px;background:rgba(255,255,255,0.25);top:92%;left:28%;animation-duration:20s;animation-delay:-1s; }
  .sp-particle:nth-child(5) { width:4px;height:4px;background:rgba(196,181,253,0.4);top:88%;left:75%;animation-duration:15s;animation-delay:-7s; }
  .sp-particle:nth-child(6) { width:3px;height:3px;background:rgba(255,255,255,0.35);top:95%;left:52%;animation-duration:22s;animation-delay:-3s; }
  .sp-particle:nth-child(7) { width:4px;height:4px;background:rgba(165,180,252,0.35);top:78%;left:8%;animation-duration:17s;animation-delay:-9s; }
  .sp-particle:nth-child(8) { width:3px;height:3px;background:rgba(255,255,255,0.3);top:82%;left:88%;animation-duration:19s;animation-delay:-6s; }
  /* Twinkle stars */
  .sp-particle:nth-child(9) { width:2px;height:2px;background:rgba(255,255,255,0.6);top:10%;left:18%;animation-duration:2.5s;animation-delay:0s; }
  .sp-particle:nth-child(10) { width:2px;height:2px;background:rgba(255,255,255,0.5);top:25%;left:72%;animation-duration:3.5s;animation-delay:-1.2s; }
  .sp-particle:nth-child(11) { width:2px;height:2px;background:rgba(255,255,255,0.4);top:60%;left:85%;animation-duration:4s;animation-delay:-2.5s; }
  .sp-particle:nth-child(12) { width:2px;height:2px;background:rgba(255,255,255,0.5);top:45%;left:5%;animation-duration:3s;animation-delay:-0.8s; }

  @keyframes spDriftUp {
    0% { opacity:0; transform:translateY(0) translateX(0); }
    8% { opacity:0.8; }
    92% { opacity:0.8; }
    100% { opacity:0; transform:translateY(-500px) translateX(30px); }
  }
  @keyframes spTwinkle {
    0%, 100% { opacity:0.1; transform:scale(0.8); }
    50% { opacity:0.9; transform:scale(1.2); }
  }

  /* Stat cards — glassmorphism */
  .sp-stat {
    position: absolute; z-index: 8; pointer-events: none;
    background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.12);
    backdrop-filter: blur(14px); -webkit-backdrop-filter: blur(14px);
    border-radius: 14px; padding: 12px 16px; text-align: center;
    box-shadow: 0 8px 32px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.08);
  }
  .sp-stat-val { font-size: 20px; font-weight: 800; color: #fff; line-height: 1; margin-bottom: 3px; }
  .sp-stat-lbl { font-size: 9px; font-weight: 500; color: rgba(255,255,255,0.6); text-transform: uppercase; letter-spacing: 0.06em; white-space: nowrap; }
  .sp-stat-1 { top: 8%; left: 5%; animation: spStatF1 7s ease-in-out infinite; }
  .sp-stat-2 { top: 12%; right: 4%; animation: spStatF2 8s ease-in-out infinite; animation-delay: -2s; }
  .sp-stat-3 { bottom: 10%; left: 6%; animation: spStatF3 9s ease-in-out infinite; animation-delay: -4s; }
  @keyframes spStatF1 { 0%,100%{transform:translateY(0) rotate(0deg);} 30%{transform:translateY(-12px) rotate(1.5deg);} 70%{transform:translateY(-5px) rotate(-1deg);} }
  @keyframes spStatF2 { 0%,100%{transform:translateY(0) rotate(0deg);} 40%{transform:translateY(-10px) rotate(-2deg);} 80%{transform:translateY(-4px) rotate(1deg);} }
  @keyframes spStatF3 { 0%,100%{transform:translateY(0) rotate(0deg);} 25%{transform:translateY(-14px) rotate(1deg);} 60%{transform:translateY(-7px) rotate(-1.5deg);} }

  /* Feature badges */
  .sp-badge {
    position: absolute; z-index: 8; pointer-events: none;
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.10);
    backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
    border-radius: 20px; padding: 5px 12px; font-size: 10px; font-weight: 600;
    color: rgba(255,255,255,0.75); white-space: nowrap; display: flex; align-items: center; gap: 5px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  }
  .sp-badge-1 { bottom: 24%; right: 3%; animation: spBadgeF 10s ease-in-out infinite; }
  .sp-badge-2 { top: 36%; left: 2%; animation: spBadgeF 12s ease-in-out infinite; animation-delay: -3s; }
  .sp-badge-3 { bottom: 36%; left: 10%; animation: spBadgeF 11s ease-in-out infinite; animation-delay: -6s; }
  .sp-badge-4 { top: 28%; right: 6%; animation: spBadgeF 9s ease-in-out infinite; animation-delay: -1.5s; }
  @keyframes spBadgeF {
    0%,100%{transform:translateY(0) translateX(0);} 30%{transform:translateY(-8px) translateX(5px);} 60%{transform:translateY(-14px) translateX(-3px);} 85%{transform:translateY(-4px) translateX(2px);}
  }

  /* Glassmorphism illustration */
  .sp-illus { position: relative; width: 240px; height: 180px; margin: 0 auto 28px; z-index: 5; }
  .sp-illus-main {
    position: absolute; width: 140px; height: 100px; top: 40px; left: 50px;
    background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.15);
    backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
    border-radius: 16px; animation: spShapeF1 6s ease-in-out infinite;
    box-shadow: 0 8px 32px rgba(0,0,0,0.1);
  }
  .sp-illus-main::before { content:''; position:absolute; top:16px; left:16px; right:16px; height:7px; background:rgba(255,255,255,0.25); border-radius:4px; }
  .sp-illus-main::after { content:''; position:absolute; top:32px; left:16px; width:70px; height:5px; background:rgba(255,255,255,0.15); border-radius:3px; }
  .sp-illus-sm1 {
    position: absolute; width: 70px; height: 50px; top: 15px; left: 8px;
    background: rgba(139,92,246,0.20); border: 1px solid rgba(139,92,246,0.25);
    border-radius: 12px; animation: spShapeF2 5s ease-in-out infinite; animation-delay: -1.5s;
  }
  .sp-illus-sm1::before { content:''; position:absolute; top:12px; left:12px; width:18px; height:18px; background:rgba(139,92,246,0.35); border-radius:7px; }
  .sp-illus-sm2 {
    position: absolute; width: 75px; height: 45px; top: 25px; right: 0;
    background: rgba(99,102,241,0.18); border: 1px solid rgba(99,102,241,0.22);
    border-radius: 12px; animation: spShapeF3 7s ease-in-out infinite; animation-delay: -3s;
  }
  .sp-illus-sm2::before { content:''; position:absolute; top:12px; left:12px; right:12px; height:5px; background:rgba(99,102,241,0.30); border-radius:3px; }
  .sp-illus-bar {
    position: absolute; width: 170px; height: 36px; bottom: 8px; left: 35px;
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.10);
    border-radius: 10px; animation: spShapeF1 8s ease-in-out infinite; animation-delay: -2s;
    display: flex; align-items: center; padding: 0 12px; gap: 8px;
  }
  .sp-illus-dot { width:8px; height:8px; border-radius:50%; background:rgba(52,211,153,0.6); animation: spPulse 2s ease infinite; }
  .sp-illus-line { flex:1; height:4px; background:rgba(255,255,255,0.12); border-radius:2px; }

  @keyframes spShapeF1 { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-10px);} }
  @keyframes spShapeF2 { 0%,100%{transform:translateY(0) rotate(0deg);} 40%{transform:translateY(-8px) rotate(-1.5deg);} 70%{transform:translateY(-14px) rotate(0.5deg);} }
  @keyframes spShapeF3 { 0%,100%{transform:translateY(0) translateX(0);} 30%{transform:translateY(-7px) translateX(3px);} 60%{transform:translateY(-15px) translateX(-2px);} }
  @keyframes spPulse { 0%,100%{opacity:1;transform:scale(1);} 50%{opacity:0.5;transform:scale(0.85);} }

  /* Brand content */
  .signup-left-brand {
    position: relative !important; z-index: 10 !important; text-align: center !important; max-width: 340px !important;
  }
  .signup-brand-logo {
    max-width: 100px !important; width: auto !important; height: auto !important;
    margin-bottom: 20px !important; border-radius: 10px !important; opacity: 0.95;
    display: block !important; margin-left: auto !important; margin-right: auto !important;
  }
  .signup-illustration { display: none !important; }
  .signup-left-brand h2 { color: #fff !important; font-size: 24px !important; font-weight: 700 !important; margin-bottom: 8px !important; letter-spacing: -0.4px !important; }
  .signup-left-brand p { color: rgba(255,255,255,0.6) !important; font-size: 13px !important; line-height: 1.7 !important; margin: 0 auto !important; }

  /* ============================================================
     RIGHT PANEL
     ============================================================ */
  .signup-right-panel {
    width: 55% !important; min-width: 55% !important; height: 100vh !important;
    background: #F8FAFC !important; display: flex !important; align-items: center !important;
    justify-content: center !important; overflow-y: auto !important; padding: 20px 28px !important;
    box-sizing: border-box !important; position: relative !important;
  }
  .signup-right-panel::before {
    content: '' !important; position: absolute !important; inset: 0 !important;
    background-image: radial-gradient(circle, rgba(99,102,241,0.07) 1px, transparent 1px) !important;
    background-size: 32px 32px !important; opacity: 0.4 !important; pointer-events: none !important;
    mask-image: radial-gradient(ellipse 50% 50% at 50% 50%, black 10%, transparent 70%);
    -webkit-mask-image: radial-gradient(ellipse 50% 50% at 50% 50%, black 10%, transparent 70%);
  }

  /* ============================================================
     SIGNUP CARD
     ============================================================ */
  .signup-card {
    max-width: 520px !important; width: 100% !important; background: #fff !important;
    border-radius: 20px !important; padding: 28px 32px 24px !important;
    box-shadow: 0 8px 32px rgba(0,0,0,0.07), 0 2px 8px rgba(0,0,0,0.03) !important;
    border: 1px solid #E2E8F0 !important; position: relative !important; z-index: 2 !important;
    box-sizing: border-box !important;
  }

  .signup-eyebrow {
    display: inline-flex !important; align-items: center !important; gap: 6px !important;
    font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase !important;
    letter-spacing: 1px !important; color: #7B5AC4 !important; margin-bottom: 6px !important;
    background: rgba(99,102,241,0.08) !important; padding: 4px 12px 4px 8px !important;
    border-radius: 20px !important;
  }
  .signup-eyebrow::before {
    content: '\\2728' !important; display: inline-block !important; font-size: 12px !important;
    width: auto !important; height: auto !important; background: none !important;
  }

  .signup-card-title { font-size: 20px !important; font-weight: 700 !important; color: #1E293B !important; margin: 0 0 3px 0 !important; letter-spacing: -0.3px !important; }
  .signup-card-subtitle { font-size: 13px !important; color: #94A3B8 !important; margin-bottom: 16px !important; }

  /* ============================================================
     ISSUE 2 FIX — Labels ABOVE inputs
     ============================================================ */
  .signup-card .input-field,
  .signup-card .input-field.signup-field,
  .signup-card .signup-field {
    display: flex !important;
    flex-direction: column !important;
    margin-top: 0 !important;
    margin-bottom: 10px !important;
    position: relative !important;
  }

  .signup-card .input-field label,
  .signup-card label {
    position: static !important;
    transform: none !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #475569 !important;
    letter-spacing: 0.01em !important;
    margin-bottom: 5px !important;
    pointer-events: auto !important;
    order: -1 !important;
    width: fit-content !important;
    left: auto !important;
    top: auto !important;
  }

  /* ============================================================
     ISSUE 3 FIX — Hide asterisk on phone fields only + helper text
     ============================================================ */
  .signup-card .input-field[class*="signup-field"] label .required-star,
  .signup-card .signup-field label .required-star,
  .signup-phone-row .signup-field label span[style*="color: red"],
  .signup-phone-row .signup-field label .required,
  .signup-phone-row label span:last-child {
    display: none !important;
  }

  .sp-phone-hint {
    font-size: 11px !important; color: #94A3B8 !important; margin: 2px 0 10px 0 !important;
    font-style: italic !important;
  }

  /* Hide asterisks on phone fields — only one is required */
  .signup-phone-row .required,
  .signup-phone-row label span[style*="red"],
  .signup-phone-row .input-field label .required-star {
    display: none !important;
  }

  /* ============================================================
     FORM LAYOUT
     ============================================================ */
  .signup-form { width: 100% !important; }
  .signup-row { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 12px !important; }
  .signup-row > * { min-width: 0 !important; }

  /* Input theme */
  .signup-card input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]),
  .signup-card .select-wrapper input.select-dropdown {
    background: #F8FAFC !important; border: 1.5px solid #E2E8F0 !important;
    border-radius: 8px !important; height: 42px !important; padding: 0 14px !important;
    font-size: 14px !important; font-weight: 500 !important; font-family: 'Inter', sans-serif !important;
    color: #1E293B !important; box-shadow: 0 1px 2px rgba(0,0,0,0.04) !important;
    outline: none !important; transition: all 0.25s cubic-bezier(0.16,1,0.3,1) !important;
    box-sizing: border-box !important; margin: 0 !important; width: 100% !important;
  }
  .signup-card input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):focus,
  .signup-card .select-wrapper input.select-dropdown:focus {
    background: #fff !important; border-color: #7B5AC4 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.15), 0 1px 2px rgba(0,0,0,0.04) !important;
  }
  .signup-card input::placeholder { color: #94A3B8 !important; font-weight: 400 !important; }

  .signup-card input[type="number"]::-webkit-outer-spin-button,
  .signup-card input[type="number"]::-webkit-inner-spin-button { -webkit-appearance: none !important; }
  .signup-card input[type="number"] { -moz-appearance: textfield !important; }

  /* Verify links — indigo */
  .signup-card .verify .text { color: #7B5AC4 !important; font-weight: 600 !important; font-size: 12px !important; }
  .signup-card .verify .status { color: #10B981 !important; font-weight: 600 !important; font-size: 12px !important; }

  /* Phone input */
  .signup-card .phone-input-wrapper { display: flex !important; align-items: center !important; }
  .signup-card .phone-input-wrapper .phone-input { width: 100% !important; flex: 1 !important; min-width: 0 !important; }
  .signup-card .phone-input-container { overflow: hidden !important; }

  /* Hide all field icons */
  .signup-card .place-icon-left,
  .signup-card .place-icon-right,
  .signup-card .view-password {
    display: none !important;
  }

  /* ============================================================
     ISSUE 4 FIX — Button indigo gradient
     ============================================================ */
  .signup-submit-btn,
  .signup-card .btn,
  .signup-card .btn-large {
    width: 100% !important; height: 46px !important; line-height: 46px !important;
    border: none !important; border-radius: 12px !important;
    background: linear-gradient(135deg, #7B5AC4 0%, #8B5CF6 100%) !important;
    color: #fff !important; font-size: 15px !important; font-weight: 600 !important;
    font-family: 'Inter', sans-serif !important; cursor: pointer !important;
    box-shadow: 0 4px 15px rgba(99,102,241,0.4) !important;
    transition: all 0.3s cubic-bezier(0.16,1,0.3,1) !important;
    text-transform: none !important; display: flex !important; align-items: center !important;
    justify-content: center !important; position: relative !important; overflow: hidden !important;
  }
  .signup-submit-btn::after {
    content: ''; position: absolute; top: 0; left: 0; width: 40%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
    z-index: 1; pointer-events: none; animation: spShimmer 3s ease-in-out infinite; animation-delay: 1s;
  }
  @keyframes spShimmer { 0%{transform:translateX(-100%) skewX(-15deg);} 100%{transform:translateX(250%) skewX(-15deg);} }
  .signup-submit-btn:hover,
  .signup-card .btn:hover,
  .signup-card .btn-large:hover {
    background: linear-gradient(135deg, #6A4DB3 0%, #7C3AED 100%) !important;
    box-shadow: 0 6px 20px rgba(99,102,241,0.5) !important;
    transform: translateY(-1px) !important;
  }
  .signup-submit-btn.disabled-btn,
  .signup-card .btn.disabled-btn {
    background: #E2E8F0 !important; color: #94A3B8 !important; cursor: not-allowed !important;
    box-shadow: none !important; transform: none !important; opacity: 0.6 !important;
    pointer-events: none !important;
  }
  .signup-submit-btn.disabled-btn::after { display: none !important; }

  /* Feedback */
  .signup-feedback { background: #FFF7ED !important; border-left: 3px solid #F59E0B !important; border-radius: 8px !important; padding: 10px 14px !important; margin-bottom: 10px !important; }
  .signup-feedback span { font-size: 12px !important; color: #C2410C !important; font-weight: 500 !important; }

  /* Terms & Footer */
  .signup-terms { font-size: 11px !important; line-height: 1.6 !important; color: #94A3B8 !important; margin-top: 14px !important; text-align: center !important; }
  .signup-terms a { color: #7B5AC4 !important; text-decoration: none !important; font-weight: 500 !important; }
  .signup-terms a:hover { text-decoration: underline !important; }
  .signup-footer-link { text-align: center !important; margin-top: 14px !important; padding-top: 12px !important; border-top: 1px solid #E2E8F0 !important; font-size: 13px !important; color: #94A3B8 !important; }
  .signup-footer-link a { color: #7B5AC4 !important; font-weight: 600 !important; text-decoration: none !important; }
  .signup-footer-link a:hover { color: #6A4DB3 !important; text-decoration: underline !important; }

  /* Responsive */
  @media (max-width: 992px) {
    .signup-page-wrapper { flex-direction: column !important; height: auto !important; overflow-y: auto !important; }
    .signup-left-panel { width: 100% !important; min-width: 100% !important; max-width: 100% !important; height: 200px !important; padding: 20px !important; }
    .sp-stat, .sp-badge, .sp-illus { display: none !important; }
    .signup-right-panel { width: 100% !important; min-width: 100% !important; height: auto !important; padding: 20px 16px !important; }
    .signup-card { padding: 24px 20px !important; }
    .signup-row { grid-template-columns: 1fr !important; gap: 0 !important; }
  }
  @media (max-width: 600px) {
    .signup-left-panel { display: none !important; }
    .signup-right-panel { width: 100% !important; min-width: 100% !important; }
    .signup-card { border-radius: 12px !important; padding: 20px 16px !important; }
  }
`;

const SignupPage = () => {
  return (
    <>
      <style>{signupStyles}</style>
      <div className="signup-page-wrapper">
        {/* ======== LEFT PANEL — matches login page ======== */}
        <div className="signup-left-panel">
          {/* Aurora */}
          <div className="sp-aurora"></div>
          {/* Orbs */}
          <div className="sp-orb sp-orb-1"></div>
          <div className="sp-orb sp-orb-2"></div>
          <div className="sp-orb sp-orb-3"></div>
          {/* Grid + Noise */}
          <div className="sp-grid"></div>
          <div className="sp-noise"></div>

          {/* Floating particles (8 drift + 4 twinkle) */}
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-drift"></div>
          <div className="sp-particle sp-twinkle"></div>
          <div className="sp-particle sp-twinkle"></div>
          <div className="sp-particle sp-twinkle"></div>
          <div className="sp-particle sp-twinkle"></div>

          {/* Stat cards */}
          <div className="sp-stat sp-stat-1">
            <div className="sp-stat-val">10,000+</div>
            <div className="sp-stat-lbl">Interviews Conducted</div>
          </div>
          <div className="sp-stat sp-stat-2">
            <div className="sp-stat-val">500+</div>
            <div className="sp-stat-lbl">Companies Trust Us</div>
          </div>
          <div className="sp-stat sp-stat-3">
            <div className="sp-stat-val">98%</div>
            <div className="sp-stat-lbl">Time Saved</div>
          </div>

          {/* Feature badges */}
          <div className="sp-badge sp-badge-1"><span>&#9889;</span> AI-Powered Scoring</div>
          <div className="sp-badge sp-badge-2"><span>&#127909;</span> Video Interviews</div>
          <div className="sp-badge sp-badge-3"><span>&#128202;</span> Smart Analytics</div>
          <div className="sp-badge sp-badge-4"><span>&#128197;</span> Auto Scheduling</div>

          {/* Brand content */}
          <div className="signup-left-brand">
            <img className="signup-brand-logo" src={image.brandStrategicPartnerLogo} alt="Ample Hire" />
            <img className="signup-illustration" src={image.userSignupSigninPageImage} alt="" />

            {/* Glassmorphism illustration */}
            <div className="sp-illus">
              <div className="sp-illus-sm1"></div>
              <div className="sp-illus-sm2"></div>
              <div className="sp-illus-main"></div>
              <div className="sp-illus-bar">
                <div className="sp-illus-dot"></div>
                <div className="sp-illus-line"></div>
              </div>
            </div>

            <h2>Join Ample Hire</h2>
            <p>Trusted by hiring teams to manage candidates, schedule interviews, and close roles faster.</p>
            <ul style={{ listStyle: "none", padding: 0, marginTop: 20, display: "flex", flexDirection: "column", gap: 10, textAlign: "left", alignItems: "center" }}>
              {[
                "Centralized candidate pipeline",
                "AI-powered interview scoring",
                "Real-time team collaboration",
              ].map((item) => (
                <li key={item} style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <span style={{ width: 18, height: 18, borderRadius: "50%", background: "rgba(99,102,241,0.2)", border: "1px solid rgba(99,102,241,0.3)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 9, color: "#a5b4fc" }}>&#10003;</span>
                  <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", fontWeight: 500 }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ======== RIGHT PANEL ======== */}
        <div className="signup-right-panel">
          <SignupForm />
        </div>
      </div>
    </>
  );
};

export default SignupPage;
